exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".onboarding-status {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex-grow: 1;\n}\n\n.onboarding-status>button {\n  margin-bottom: 5rem;\n}\n\n.onboarding-status>div {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 25rem;\n}\n\n.onboarding-status>div>span {\n  font-size: 3.5rem;\n  text-transform: uppercase;\n  padding-left: 2rem;\n  align-self: center;\n}\n\n.onboarding-status>div>svg {\n  height: 6rem;\n  width: 6rem;\n}\n\n@media only screen and (min-width: 768px) {\n  .onboarding-status>div {\n    margin-top: 50rem;\n  }\n}\n\n", ""]);

// exports
